import React, {Component} from 'react'
import PropTypes from "prop-types"
import './style.css'
import _ from 'lodash'
import UploadDropzone from "../../../../components/_common/form/FormInput/UploadDropzone"
import BannerList from "../../../../components/_admin/BannerList"
import BannerThumbnail from "../../../../components/_admin/BannerThumbnail"
import NRTBannerForm from "../../../../components/_admin/BannerForm"
import {uploadToS3} from "../../../../helpers/aws"
import NRTModal from "../../../../components/_common/Modal"
import NRTButton from "../../../../components/_common/_buttons/Button"
import Spinner from "../../../../components/_common/Spinner"


class TabBannersConfig extends Component {

    state = {
        awaiting: false,
        activeBanner: null,
        confirmDialogOpen: false,
        removingBanner: null,
    }


    startUpload = acceptedFiles => {

        const {
            schema,
            s3Type
        } = this.props


        this.setState({
            awaiting: true
        }, () => {
            Promise
                .all(acceptedFiles.map(file => uploadToS3(schema, file, s3Type, true)))
                .then(imgLocations => {

                    this.props.onSave([
                        ...this.props.banners,
                        ...imgLocations
                            .filter(imgLocation => !this.props.banners.some(banner => banner.imgSrc === imgLocation))
                            .map(imgLocation => ({
                                imgSrc: imgLocation,
                                title: '',
                                subtitle: '',
                                actionButton: ''
                            }))
                    ])

                    this.setState({awaiting: false})
                })
                .catch(error => {
                    this.setState({awaiting: false})
                })
        })


    }


    onSave = (banner) => {
        const newBanners = [...this.props.banners]
        const bannerIndex = _.findIndex(newBanners, banner => banner.imgSrc === this.state.activeBanner.imgSrc)
        newBanners[bannerIndex] = {
            ...newBanners[bannerIndex],
            ...banner
        }

        this.props.onSave(newBanners)

    }

    showConfirmRemoveDialog = (banner) => {
        this.setState({
            confirmDialogOpen: true,
            removingBanner: banner
        })
    }

    closeRemoveDialog = () => {
        this.setState({
            confirmDialogOpen: false,
            removingSlideIndex: null,
        })
    }


    removeSlide = () => {


        this.props.onSave(
            this.props.banners.filter(banner => banner.imgSrc !== this.state.removingBanner.imgSrc)
        )
        this.closeRemoveDialog()
    }


    bannerSelected = (banner) => {
        this.setState({activeBanner: null}, ()=>this.setState({activeBanner:banner}))
    }


    render() {

        const {
            activeBanner,
            awaiting,
        } = this.state

        const {
            banners
        } = this.props

        return (
            <div className={'nrt-admin-slides-page'}>

                <NRTModal title={'Deseja remover este banner da página inicial?'}
                          open={this.state.confirmDialogOpen}

                          onOverlayClick={this.closeRemoveDialog}
                          buttons={[
                              <NRTButton content={'cancelar'}
                                         onClick={this.closeRemoveDialog}
                                         outline
                              />,
                              <NRTButton content={'remover'}
                                         onClick={this.removeSlide}
                                         danger
                              />
                          ]}
                />


                <div className={'dropzone-container'}>
                    {
                        awaiting ?
                            <div style={{opacity: .5}}>
                                <Spinner/>
                            </div> :
                            <UploadDropzone
                                className={'nrt-upload-dropzone'}
                                activeClassName={'nrt-upload-dropzone-active'}
                                rejectClassName={'nrt-upload-dropzone-rejected'}
                                onDrop={this.startUpload}
                            />
                    }
                </div>


                <label>Clique na imagem para editar as configurações de exibição:</label>

                <BannerList>
                    {
                        banners.map((banner, index) =>
                            <BannerThumbnail key={'banner-' + index}
                                             banner={banner}
                                             active={_.get(activeBanner, 'imgSrc') === banner.imgSrc}
                                             onRemoveButtonClick={() => this.showConfirmRemoveDialog(banner)}
                                             onClick={() => this.bannerSelected(banner)}/>
                        )
                    }
                </BannerList>

                {
                    activeBanner &&
                    <NRTBannerForm banner={activeBanner}
                                   onSave={this.onSave}
                    />
                }

            </div>
        )
    }
}


TabBannersConfig.propTypes = {
    banners: PropTypes.array.isRequired,
    schema: PropTypes.string.isRequired,
    s3ParentType: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired,

}

TabBannersConfig.defaultProps = {}

export default TabBannersConfig



// WEBPACK FOOTER //
// ./src/_pages/Admin/_partials/TabBannersConfig/index.js